import { ChakraProvider } from '@chakra-ui/react';

import { ITheme, ThemeProvider } from '~/shared/hooks/useTheme';
import { SideBarProvider } from '~/shared/hooks/useSideBar';
import { PermissionsProvider } from '~/shared/hooks/usePermissions';
import { ModalProvider } from '~/shared/hooks/useModal';
import { AuthProvider } from '~/modules/auth/hooks/useAuth';

import { WithChildren } from '~/shared/types/WithChildren';
import { IResale } from '../../../modules/resales/interfaces/IResale';

interface IAppProviderProps {
  defaultTheme: ITheme;
  currentAccessResale: IResale;
  currentAccessId: string;
}

export const AppProvider: WithChildren<IAppProviderProps> = ({
  children,
  defaultTheme,
  currentAccessResale,
  currentAccessId,
}) => {
  return (
    <ChakraProvider resetCSS={false}>
      <AuthProvider
        currentAccessResale={currentAccessResale}
        currentAccessId={currentAccessId}
      >
        <ThemeProvider defaultTheme={defaultTheme}>
          <PermissionsProvider>
            <ModalProvider>
              <SideBarProvider>{children}</SideBarProvider>
            </ModalProvider>
          </PermissionsProvider>
        </ThemeProvider>
      </AuthProvider>
    </ChakraProvider>
  );
};
